import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './BlogPost.css';
import lucasAvatar from '../img/team/lucas.jpg';
import BlogTemplate from '../components/common/BlogTemplate';

class BlogPost extends Component {
  render() {
    return (
      <BlogTemplate {...this.props}>
        <h1>Meet Lucas - Our Graduate Engineer</h1>
        <h2>
          This blog post was written by Lucas Amos our new Graduate Software
          Engineer who wanted to share the experience of his first month working
          on one of the arc-net  products - distilled ID  platform.
        </h2>
        <div className="center">
          <img className="avatar" src={lucasAvatar} alt="Lucas Amos - our graduate devloper" />
        </div>
        <p>
          After 6 years in academia, I figured that it was about time that I
          entered the world of work and after my first month at arc-net I
          can confidently say that I have chosen the right place.
        </p>
        <p>
          During my time at university, I worked on a wide range of projects
          using many programming languages and technologies. However, the nature
          of university life means that once you finish one deadline you move
          straight on to the next one, rarely getting time to gain deep
          knowledge of a particular subject so I was really looking forward
          to learning some new skills.
        </p>
        <p>
          At other companies new hires might spend their first week filling out
          forms, making coffee and attending orientation meetings. Not at arc-net,
          after spending a few days familiarising myself with the platform I was
          learning React and by the end of the second week, I was putting those
          skills to use developing Distilled ID’s brand new web presence. A
          reactive web framework has long been at the top of my list of skills
          that I wanted to learn so it has been great to finally get deeply
          involved in such a project.
        </p>
        <p>
          The team here is tight-knit, constantly collaborating to improve the
          shipped product and involving the whole team in discussions about its
          future from both a technical and business perspective, another advantage
          of not being just a small cog in a machine.
        </p>
        <p>
          At the end of my first month at arc-net I now have a good understanding of
          the business proposition along with a solid grounding in React, state
          management, routing, CSS and JavaScript and I am looking forward to
          working on our next project using ReactNative.
        </p>
        <div className="footnote">
          <p>
            At arc-net we are always on the lookout for talented graduates who can add their
            skills to our dynamic team where they can take personal ownership of their work.
                Please see our <Link to="/graduates">graduates page</Link> for more information.
          </p>
        </div>
      </BlogTemplate>
    );
  }
}

export default BlogPost;



// WEBPACK FOOTER //
// ./src/blogposts/lucasNovember2018.js